var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuAdaptiveClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.52714 0.211388C1.33188 0.0161259 1.01529 0.0161259 0.820031 0.211388C0.624768 0.40665 0.624768 0.723233 0.820031 0.918495L1.52714 0.211388ZM0.820031 0.918495L27.6901 27.7886L28.3972 27.0814L1.52714 0.211388L0.820031 0.918495Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6901 0.211388C27.8854 0.0161259 28.202 0.0161259 28.3973 0.211388C28.5925 0.40665 28.5925 0.723233 28.3973 0.918495L27.6901 0.211388ZM28.3973 0.918495L1.5272 27.7886L0.820091 27.0814L27.6901 0.211388L28.3973 0.918495Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuAdaptiveClose);
export default __webpack_public_path__ + "static/media/menu_adaptive_close.c23552a4a6d6e3ec25912cebd446ffc5.svg";
export { ForwardRef as ReactComponent };